import { useQueryParams } from '@atlas-frontend/sdk';

export function useInputDataParameters() {
  const [{ inputDataVersionId, outputDataVersionId }] = useQueryParams();

  return {
    inputDataVersionId: inputDataVersionId
      ? Number(inputDataVersionId)
      : undefined,
    outputDataVersionId: outputDataVersionId
      ? Number(outputDataVersionId)
      : undefined,
  };
}
